import snakeCase from 'lodash/snakeCase';

// Feature flags naming convention: https://goatapp.atlassian.net/wiki/spaces/FRON/pages/118751233/Using+Feature+Flags
export enum FeatureFlags {
  // Permanent Flags
  // ---------------------------------------------------------------------------
  WEB_ALLOW_EXPERIMENTS = 'webAllowExperiments',
  WEB_ENABLE_AFFIRM = 'webEnableAffirm',
  WEB_ENABLE_AFTERPAY = 'webEnableAfterpay',
  WEB_ENABLE_ALIPAY = 'webEnableAlipay',
  WEB_ENABLE_ATMOE = 'webEnableAtmoe',
  WEB_ENABLE_BLACK_FRIDAY_BLACKOUT = 'webEnableBlackFridayBlackout',
  WEB_ENABLE_BLACK_FRIDAY_COMMUNITY = 'webEnableBlackFridayCommunity',
  WEB_ENABLE_BLACK_FRIDAY_IN_NAV = 'webEnableBlackFridayInNav',
  WEB_ENABLE_BLACK_FRIDAY_USER_PROFILE = 'webEnableBlackFridayUserProfile',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS = 'webEnableCheckoutGiftCards',
  WEB_ENABLE_CHECKOUT_PURCHASE_GIFT_CARDS = 'webEnableCheckoutPurchaseGiftCards',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS_ALLOW_GUEST_REDEMPTION = 'webEnableCheckoutGiftCardsAllowGuestRedemption',
  WEB_ENABLE_CHECKOUT_GIFT_CARDS_ALLOW_GUEST_PURCHASE = 'webEnableCheckoutGiftCardsAllowGuestPurchase',
  WEB_ENABLE_CHECKOUT_OFFERS = 'webEnableCheckoutOffers',
  WEB_ENABLE_DEFAULT_HOME_TAB_BRAND = 'webEnableDefaultHomeTabBrand',
  WEB_ENABLE_DEFAULT_HOME_TAB_DISCOVER = 'webEnableDefaultHomeTabDiscover',
  WEB_ENABLE_GIROPAY = 'webEnableGiropay',
  WEB_ENABLE_GOAT_BANNER = 'webEnableGoatBanner',
  WEB_ENABLE_GOOGLE_RECAPTCHA = 'webEnableGoogleRecaptcha',
  WEB_ENABLE_GUEST_CHECKOUT = 'webEnableGuestCheckout',
  WEB_ENABLE_HOMEPAGE_BRAND_TAB = 'webEnableHomepageBrandTab',
  WEB_ENABLE_HOW_TO_PLAY_MOBILE_REDIRECT = 'webEnableHowToPlayMobileRedirect',
  WEB_ENABLE_IMPACT = 'webEnableImpact',
  WEB_ENABLE_KLARNA = 'webEnableKlarna',
  WEB_ENABLE_LATEST_SEARCHES = 'webEnableLatestSearches',
  WEB_ENABLE_MANIFESTO_COLLECTION = 'webEnableManifestoCollection',
  WEB_ENABLE_MPARTICLE = 'webEnableMparticle',
  WEB_ENABLE_ONE_TRUST = 'webEnableOneTrust',
  WEB_ENABLE_ON_SALE = 'webEnableOnSale',
  WEB_ENABLE_PAYPAL = 'webEnablePaypal',
  WEB_ENABLE_POST_BLACK_FRIDAY = 'webEnablePostBlackFriday',
  WEB_ENABLE_PRE_BLACK_FRIDAY = 'webEnablePreBlackFriday',
  WEB_ENABLE_RECENT_SEARCHES = 'webEnableRecentSearches',
  WEB_ENABLE_SEARCH_COLLECTION_SUGGESTIONS = 'webEnableSearchCollectionSuggestions',
  WEB_ENABLE_SERVER_CACHE_BRAND_FEED = 'webEnableServerCacheBrandFeed',
  WEB_ENABLE_SERVER_CACHE_BREADCRUMBS = 'webEnableServerCacheBreadcrumbs',
  WEB_ENABLE_SERVER_CACHE_DISCOVER_FEED = 'webEnableServerCacheDiscoverFeed',
  WEB_ENABLE_SNAPCHAT = 'webEnableSnapchat',
  WEB_ENABLE_SUGGESTED_SEARCHES = 'webEnableSuggestedSearches',
  WEB_ENABLE_TIKTOK = 'webEnableTiktok',
  WEB_ENABLE_TOGGLE_NEXT_PREV_BRAND_FEED = 'webEnableToggleNextPrevBrandFeed',
  WEB_ENABLE_TOGGLE_NEXT_PREV_MANIFESTO = 'webEnableToggleNextPrevManifesto',

  // Temporary Flags
  // ---------------------------------------------------------------------------
  TEMP_WEB_ENABLE_ADD_DISCOVER_TO_HOMEPAGE_BACKGROUND = 'tempWebEnableAddDiscoverToHomepageBackground',
  TEMP_WEB_ENABLE_AFFIRM_AUTO_PURCHASE = 'tempWebEnableAffirmAutoPurchase',
  TEMP_WEB_ENABLE_AFTERPAY_AUTO_PURCHASE = 'tempWebEnableAfterpayAutoPurchase',
  TEMP_WEB_ENABLE_AUCTIONS = 'tempWebEnableAuctions',
  TEMP_WEB_ENABLE_AUCTIONS_TEST = 'tempWebEnableAuctionsTest',
  TEMP_WEB_ENABLE_BLACK_FRIDAY_SCHEDULE = 'tempWebEnableBlackFridaySchedule',
  TEMP_WEB_ENABLE_BLACK_FRIDAY_TRIVIA = 'tempWebEnableBlackFridayTrivia',
  TEMP_WEB_ENABLE_BRAND_STORY = 'tempWebEnableBrandStory',
  TEMP_WEB_ENABLE_CHANGE_CURRENCY_AT_CHECKOUT = 'tempWebEnableChangeCurrencyAtCheckout',
  TEMP_WEB_ENABLE_CHECKOUT_ZIP_REQUIRED = 'tempWebEnableCheckoutZipRequired',
  TEMP_WEB_ENABLE_CHINA_SHIPPING_FORM = 'tempWebEnableChinaShippingForm',
  TEMP_WEB_ENABLE_COMMUNITY_EXPLORATION = 'tempWebEnableCommunityExploration',
  TEMP_WEB_ENABLE_CONSUMER_SEGMENT_ACCESS_CALL = 'tempWebEnableConsumerSegmentAccessCall',
  TEMP_WEB_ENABLE_EDITORIAL_SPACE = 'tempWebEnableEditorialSpace',
  TEMP_WEB_ENABLE_EXPRESS_PAY_MODAL = 'tempWebEnableExpressPayModal',
  TEMP_WEB_ENABLE_FACTS_WINDOW_DEFAULT_OPEN = 'tempWebEnableFactsWindowDefaultOpen',
  TEMP_WEB_ENABLE_FIT_FEEDBACK_CM = 'tempWebEnableFitFeedbackCm',
  TEMP_WEB_ENABLE_GET_LISTINGS_FROM_CONSUMER_SEARCH = 'tempWebEnableGetListingsFromConsumerSearch',
  TEMP_WEB_ENABLE_GIFT_CARD_CHECK_BALANCE = 'tempWebEnableGiftCardCheckBalance',
  TEMP_WEB_ENABLE_GIFT_CARDS = 'tempWebEnableGiftCards',
  TEMP_WEB_ENABLE_GIFT_CARDS_ALLOW_GUEST_ACCESS = 'tempWebEnableGiftCardsAllowGuestAccess',
  TEMP_WEB_ENABLE_GIFT_CARDS_REQUIRE_EMAIL_ENTRY = 'tempWebEnableGiftCardsRequireEmailEntry',
  TEMP_WEB_ENABLE_GIFT_CARDS_USD_ONLY = 'tempWebEnableGiftCardsUsdOnly',
  TEMP_WEB_ENABLE_GOAT_OVERLAY = 'tempWebEnableGoatOverlay',
  TEMP_WEB_ENABLE_GUEST_CHECKOUT_PASSWORD = 'tempWebEnableGuestCheckoutPassword',
  TEMP_WEB_ENABLE_GUEST_CHECKOUT_PRICE_BREAKDOWN = 'tempWebEnableGuestCheckoutPriceBreakdown',
  TEMP_WEB_ENABLE_HIDE_BOTTOMS_FOR_FIT_FEEDBACK = 'tempWebEnableHideBottomsForFitFeedback',
  TEMP_WEB_ENABLE_INTERNATIONAL_ROUTING = 'tempWebEnableInternationalRouting',
  TEMP_WEB_ENABLE_KLARNA_CANADA = 'tempWebEnableKlarnaCanada',
  TEMP_WEB_ENABLE_KLARNA_CA_TAGLINE = 'tempWebEnableKlarnaCaTagline',
  TEMP_WEB_ENABLE_KLARNA_EU_TAGLINE = 'tempWebEnableKlarnaEuTagline',
  TEMP_WEB_ENABLE_KLARNA_UE_EXPANSION = 'tempWebEnableKlarnaUeExpansion',
  TEMP_WEB_ENABLE_KLARNA_US_TAGLINE = 'tempWebEnableKlarnaUsTagline',
  TEMP_WEB_ENABLE_LANGUAGE_SELECTION = 'tempWebEnableLanguageSelection',
  TEMP_WEB_ENABLE_MANIFESTO = 'tempWebEnableManifesto',
  TEMP_WEB_ENABLE_PARSE_NAV_LABEL = 'tempWebEnableParseNavLabel',
  TEMP_WEB_ENABLE_PAYMENT_AVAILABILITY_SERVICE = 'tempWebEnablePaymentAvailabilityService',
  TEMP_WEB_ENABLE_NEW_PAYPAL = 'tempWebEnableNewPaypal',
  TEMP_WEB_ENABLE_NEW_PAYPAL_OFFERS = 'tempWebEnableNewPaypalOffers',
  TEMP_WEB_ENABLE_PDP_ACTIVITY_PRICING = 'tempWebEnablePdpActivityPricing',
  TEMP_WEB_ENABLE_PDP_ROBOTS_UPDATE = 'tempWebEnablePdpRobotsUpdate',
  TEMP_WEB_ENABLE_PRICING_LIST_UPDATE = 'tempWebEnablePricingListUpdate',
  TEMP_WEB_ENABLE_PROFILE = 'tempWebEnableProfile',
  TEMP_WEB_ENABLE_PROFILE_ORDERS = 'tempWebEnableProfileOrders',
  TEMP_WEB_ENABLE_PROFILE_WANTS_REDESIGN = 'tempWebEnableProfileWantsRedesign',
  TEMP_WEB_ENABLE_PROFILE_WANTS_REDIRECT = 'tempWebEnableProfileWantsRedirect',
  TEMP_WEB_ENABLE_PSG_COLLECTION_GRID = 'tempWebEnablePsgCollectionGrid',
  TEMP_WEB_ENABLE_PSG_PREV_NEXT_BUTTONS = 'tempWebEnablePsgPrevNextButtons',
  TEMP_WEB_ENABLE_SCAVENGER_HUNT = 'tempWebEnableScavengerHunt',
  TEMP_WEB_ENABLE_SPIKE_MITIGATION = 'tempWebEnableSpikeMitigation',
  TEMP_WEB_ENABLE_STOP_GRID_REQUEST = 'tempWebEnableStopGridRequest',
  TEMP_WEB_ENABLE_UNAVAILABLE_IN_REGION = 'tempWebEnableUnavailableInRegion',
  TEMP_WEB_ENABLE_USER_SPACES = 'tempWebEnableUserSpaces',
  TEMP_WEB_ENABLE_WEB_OFFERS = 'tempWebEnableWebOffers',
  TEMP_WEB_EXPRESS_CHECKOUT = 'tempWebExpressCheckout',
  TEMP_WEB_FORCE_HIDE_ONE_TRUST = 'tempWebForceHideOneTrust',
  TEMP_WEB_FORCE_SHOW_SHIPPING_TAB = 'tempWebForceShowShippingTab',
  TEMP_ENABLE_ADDRESS_FORM_SCHEMA = 'tempEnableAddressFormSchema',
  TEMP_WEB_ENABLE_ATO_MITIGATION = 'tempWebEnableAtoMitigation',
  TEMP_WEB_NEW_PERFORMANCE_SPACE = 'tempWebNewPerformanceSpace',
  TEMP_WEB_ENABLE_CLOUDFLARE_CACHE_HOMEPAGE = 'tempWebEnableCloudflareCacheHomepage',
  TEMP_WEB_SEARCH_LANDING_COLLECTIONS_DEVICE = 'tempWebSearchLandingCollectionsDevice',
  TEMP_WEB_SEARCH_LANDING_COLLECTIONS_USER = 'tempWebSearchLandingCollectionsUser',
  TEMP_WEB_ENABLE_SEARCH_MICROFRONTEND = 'tempWebEnableSearchMicrofrontend',
}

export const getSnakeCaseFeatureFlags = (obj) => {
  return Object.keys(obj).map((key) => snakeCase(key));
};
